<template>
  <div>
    <nav-bar></nav-bar>
    <div class="layout-container">
      <router-view />
    </div>
    <footer class="footer">
      <div class="content has-text-centered">
        <p>Made with ❤️ by <strong>ichbinkour</strong></p>
      </div>
    </footer>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";

export default {
  name: "MainLayout",
  components: {
    NavBar,
  },
};
</script>

<style scoped>
.layout-container {
  margin: 5% 10% 10%;
}
</style>
